export var teamMembers = [
  {
    id: "jonas",
    name: "Jonas Hellriegel",
    role: "Gesch\u00e4ftsf\u00fchrer",
    description: "Leitet Fesch Elektrotechnik mit Vision und technischem Know-how.",
    image: "/images/wll05lyx_WhatsApp_Image_2026-03-06_at_11.30.30.jpeg",
    imagePosition: "center top"
  },
  {
    id: "patrick",
    name: "Patrick E\u00dfer",
    role: "Monteur",
    description: "Unser vielseitiger Allrounder \u2013 keine Herausforderung ist zu gro\u00df.",
    image: "/images/uxu2fx5v_WhatsApp_Image_2026-03-06_at_18.16.29__1_.jpeg",
    imagePosition: "center top"
  },
  {
    id: "fabian",
    name: "Fabian Seifert",
    role: "Monteur",
    description: "Erfahrener Monteur mit Leidenschaft f\u00fcr pr\u00e4zise Installationen.",
    image: "/images/ntsu4yrw_WhatsApp_Image_2026-03-06_at_18.16.27.jpeg",
    imagePosition: "center top"
  },
  {
    id: "florim",
    name: "Florim Rama",
    role: "Monteur",
    description: "Zuverl\u00e4ssiger Fachmann f\u00fcr Elektroinstallationen und Sicherheitstechnik.",
    image: "/images/yn8v0shx_WhatsApp_Image_2026-03-06_at_11.30.30__1_.jpeg",
    imagePosition: "center top"
  },
  {
    id: "mirijam",
    name: "Mirijam Joest",
    role: "B\u00fcromanagement",
    description: "Unterst\u00fctzt unser Team im B\u00fcromanagement und sorgt f\u00fcr reibungslose Abl\u00e4ufe.",
    image: "/images/dktma7dr_WhatsApp_Image_2026-03-06_at_11.30.24.jpeg",
    imagePosition: "center top"
  },
  {
    id: "florian-schroeder",
    name: "Florian Erik Schr\u00f6der",
    role: "Technischer Betriebsleiter",
    description: "Verantwortlich f\u00fcr die technische Betriebsleitung und Projektkoordination.",
    image: null
  },
  {
    id: "sebastian-bube",
    name: "Sebastian Bube",
    role: "Monteur",
    description: "Engagierter Monteur f\u00fcr unsere Projekte vor Ort.",
    image: null
  },
  {
    id: "elbasan-berisha",
    name: "Elbasan Berisha",
    role: "Azubi Elektroniker f\u00fcr Energie- und Geb\u00e4udetechnik",
    description: "Lernt bei uns das Handwerk von Grund auf \u2013 mit Eifer und Wissensdurst.",
    image: null
  },
  {
    id: "laura-bekendam",
    name: "Laura Bekendam",
    role: "Azubi Kauffrau f\u00fcr B\u00fcromanagement",
    description: "Unterst\u00fctzt unser Team in der kaufm\u00e4nnischen Verwaltung und Organisation.",
    image: null
  }
];
